const LIVE_SUPPORT_STEP = 'liveSupport';
const BUNDLE_STEP = 'bundle';

export {
    LIVE_SUPPORT_STEP,
    BUNDLE_STEP
};
